import { ChevronRight } from 'lucide-react';
import { Badge } from '../ui/badge';

const TONES = {
    passed: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800',
    failed: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-300 dark:border-red-800',
    pending: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800',
    neutral: 'bg-muted text-muted-foreground',
};

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-');

// Names exactly what was completed (module > phase > item), its final score and completion status
export const ResultSummary = ({ path = [], title, score, scoreLabel = 'Final score', status, details = [], testId = 'result-summary' }) => {
    const crumbs = path.filter(Boolean);
    return (
        <div className="rounded-xl border bg-card p-5 text-left" data-testid={testId}>
            {crumbs.length > 0 && (
                <p className="flex flex-wrap items-center gap-1 text-xs font-medium uppercase tracking-wide text-muted-foreground" data-testid={`${testId}-path`}>
                    {crumbs.map((c, i) => (
                        <span key={c} className="flex items-center gap-1">
                            {i > 0 && <ChevronRight className="h-3 w-3" />}{c}
                        </span>
                    ))}
                </p>
            )}
            <div className="mt-2 flex flex-wrap items-start justify-between gap-3">
                <h3 className="text-lg font-semibold leading-snug" data-testid={`${testId}-title`}>{title}</h3>
                {status && (
                    <Badge variant="outline" className={TONES[status.tone] || TONES.neutral} data-testid={`${testId}-status`}>{status.label}</Badge>
                )}
            </div>
            <div className="mt-4 flex flex-wrap items-end gap-x-8 gap-y-3">
                <div>
                    <p className="text-3xl font-bold tabular-nums" data-testid={`${testId}-score`}>{score == null ? '-' : `${Math.round(score)}%`}</p>
                    <p className="text-xs text-muted-foreground">{scoreLabel}</p>
                </div>
                {details.filter(d => d.value != null && d.value !== '').map(d => (
                    <div key={d.label} data-testid={`${testId}-${slug(d.label)}`}>
                        <p className="text-sm font-medium">{d.value}</p>
                        <p className="text-xs text-muted-foreground">{d.label}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
